import { render, staticRenderFns } from "./PosRankingsByMatchday.vue?vue&type=template&id=66d62196&scoped=true"
import script from "./PosRankingsByMatchday.vue?vue&type=script&lang=js"
export * from "./PosRankingsByMatchday.vue?vue&type=script&lang=js"
import style0 from "./PosRankingsByMatchday.vue?vue&type=style&index=0&id=66d62196&prod&lang=scss"
import style1 from "./PosRankingsByMatchday.vue?vue&type=style&index=1&id=66d62196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d62196",
  null
  
)

export default component.exports